import Cookies from "universal-cookie";

const ExternalFrame = (args) => {
    const cookies = new Cookies();
    const access_token = cookies.get("accessToken");

    const params = new URLSearchParams();
    if (access_token) params.append('token', access_token);
    if (args['path']) params.append('path', args['path']);

    const baseUrl = process.env.REACT_APP_EXTERNAL_FRAME_URL || 'http://localhost:9000';
    const iframeUrl = `${baseUrl}/iframe-redirect/${params.toString() ? `?${params.toString()}` : ''}`;

    return (
        <iframe width="100%" height="100%" src={iframeUrl} frameBorder={0}></iframe>
    )
}

export default ExternalFrame;